export function smoothVerticalScroll(position: number, time = 500): void {
	const currentPos = window.pageYOffset;
	let start: number | null = null;
	window.requestAnimationFrame(function step(currentTime) {
		start = !start ? currentTime : start;
		const progress = currentTime - start;
		if (currentPos < position) {
			window.scrollTo(0, ((position - currentPos) * progress) / time + currentPos);
		} else {
			window.scrollTo(0, currentPos - ((currentPos - position) * progress) / time);
		}
		if (progress < time) {
			window.requestAnimationFrame(step);
		} else {
			window.scrollTo(0, position);
		}
	});
}

export function scrollToAnchor(anchor: string): void {
	const elementToScrollTo = document.getElementById(anchor);

	if (elementToScrollTo) {
		elementToScrollTo.scrollIntoView({
			behavior: 'smooth'
		});
	}
}
